export default __webpack_public_path__ + "static/media/p52.29f3f909.jpg";